export const Palette = {
  GeoFence: '#EE8F90',
  NoFlyZone: '#CABCE8',
  FlightPath: '#8BD2EC',
  Radar: '#ffd700',
  SafePort: '#92CEA8',
  Path: '#C7BBAE',
  HighlightPath: '#B2DCF3',
  Footprint: '#EE8F90',
  WaypointMarker: '#d32f2f',
  GeoFenceMarker: '#d32f2f',
  NoFlyZoneMarker: '#ba68c8',
  SafePortMarker: '#4caf50',
};
